import React from "react";
import { withStyles } from "material-ui/styles";
import { Button, Select, MenuItem } from "material-ui";
import Dialog, {
  DialogActions,
  DialogContent,
  DialogTitle
} from "material-ui/Dialog";

import CTable, {
  CTableBody,
  CTableRow,
  CHeadCell,
  CBodyCell
} from "uis/CTable";

import CInput from "uis/CInput";

const styles = () => {
  return {
    dialogTitle: {
      width: 600
    },
    industryInput: {
      width: 400
    },
  };
};

class SelectIndustryModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      industryId: null,
      industryParentId: null
    };
  }
  render() {
    const {
      classes,
      industries,
      open
    } = this.props;
    // action
    const {
      handleClose,
      handleDecide,
      handleChange,
    } = this.props;

    return (
      <Dialog open={open}>
        <DialogTitle className={classes.dialogTitle}>産業分類選択</DialogTitle>
        <DialogContent>

          <CTable>
            <CTableBody>
              <CTableRow>
                <CHeadCell>産業分類(大分類) *</CHeadCell>
                <CBodyCell>
                  <Select
                    value={this.props.industryParentId}
                    name="modalIndustryParentId"
                    onChange={e => handleChange(e.target.name, e.target.value)}
                    input={
                      <CInput
                        name="industry-type"
                        id="industry-type"
                        className={classes.industryInput}
                      />
                    }
                  >
                    {industries.large.map(industry => (
                      <MenuItem key={industry.id} value={industry.id}>
                        {industry.name}
                      </MenuItem>
                    ))}
                  </Select>
                </CBodyCell>
              </CTableRow>

              <CTableRow>
                <CHeadCell>産業分類(中分類)</CHeadCell>
                <CBodyCell>
                  <Select
                    value={this.props.industryId}
                    name="modalIndustryId"
                    onChange={e => handleChange(e.target.name, e.target.value)}
                    input={
                      <CInput
                        name="industry-type"
                        id="industry-type"
                        className={classes.industryInput}
                      />
                    }
                  >
                    {industries.middle
                      .filter(v => v.parentId === this.props.industryParentId)
                      .map(industry => (
                        <MenuItem key={industry.id} value={industry.id}>
                          {industry.name}
                        </MenuItem>
                      ))}
                  </Select>
                </CBodyCell>
              </CTableRow>

            </CTableBody>
          </CTable>
        </DialogContent>

        <DialogActions>
          <Button raised onClick={handleClose}>
            キャンセル
          </Button>
          <Button
            raised
            onClick={() => handleDecide(this.state.industryParentId, this.state.industryId || null)}
          >
            選択
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

export default withStyles(styles)(SelectIndustryModal);



// WEBPACK FOOTER //
// ./src/components/Report/SelectIndustryModal.jsx